<template>
  <div class="right-navigation">
    <div class="right-navigation__icon-wrapper"
         v-tooltip.bottom-start="{content: 'Editorial Date Planner', ...tooltipOptions}">
      <base-material-design-icon class="right-navigation__icon"
                                 icon="calendarMinus"
                                 :class="{'right-navigation__icon_highlight': highlight === 'calendar'}"
                                 @click.stop="onClick('calendar')"/>
    </div>
    <div class="right-navigation__icon-wrapper" @click.stop="onClick('url')"
         v-tooltip.bottom-start="{content: 'Create New URL', ...tooltipOptions}">
      <base-material-design-icon class="right-navigation__icon" icon="link" />
      <div class="right-navigation__plus"></div>
    </div>
    <div class="right-navigation__icon-wrapper" @click.stop="onClick('event')"
         v-tooltip.left-start="{content: 'Create New Event', ...tooltipOptions}"
    >
      <base-material-design-icon class="right-navigation__icon" icon="star" />
      <div class="right-navigation__plus"></div>
    </div>

  </div>
</template>

<script>
/**
   * It's panel at the right side of Calendar component
   */
export default {
  name: 'CalendarRightNavPanel',
  // if 'calendar' value was sent - calendar icon will be highlighted
  // it happens if CalendarDatePlanner.vue is revealed
  props: ['highlight'],
  methods: {
    onClick (type) {
      this.$emit('navigation', type)
    }
  }
}
</script>

<style scoped lang="scss">
  .right-navigation {
    display: flex;
    margin-right: 16px;

    &__icon {
      font-size: 24px;
      cursor: pointer;

      &_highlight{
        color: $rfx-bright-turquoise;
      }
    }

    &__icon-wrapper {
      position: relative;
      display: flex;
      justify-content: center;
      margin-right: 24px;
      color: $rfx-dark-march;
      cursor: pointer;

      &:hover {
        color: $rfx-bright-turquoise;
      }
    }

    &__plus {
      position: absolute;
      top: 12px;
      right: 10px;
      width: 13px;
      height: 13px;
      background-color: currentColor;
      border-radius: 50%;
      cursor: pointer;

      &:hover {
        background-color: currentColor;
      }

      &:before,
      &:after {
        position: absolute;
        left: 6px;
        top: 3px;
        content: "";
        height: 7px;
        width: 1px;
        background-color: #fff;
      }

      &:after {
        transform: rotate(-90deg);
      }
    }
  }
</style>
